/**
 * CS: Currency Sync
 *
 * Syncs Shopify.currency.rate and Shopify.currency.active to cart attributes
 * so Liquid snippets (progress bar, clip coupon, cart summary) can convert
 * USD tier thresholds to the customer's presentment currency.
 *
 * Pattern: mirrors cs-cart-campaign-tiers.js (sessionStorage + cart attribute).
 *
 * Session behavior:
 *   - Compares current Shopify.currency values against sessionStorage.
 *   - Only calls /cart/update.js when values have changed (new session,
 *     currency switch via localization selector, etc.).
 *   - For USD (rate 1.0): clears stale attributes so Liquid defaults cleanly.
 */
(function () {
  if (!window.Shopify || !Shopify.currency) return;

  const rate = parseFloat(Shopify.currency.rate) || 1.0;
  const code = Shopify.currency.active || 'USD';

  const SK_RATE = 'cs_currency_rate';
  const SK_CODE = 'cs_currency_code';

  const lastRate = sessionStorage.getItem(SK_RATE);
  const lastCode = sessionStorage.getItem(SK_CODE);

  /* Already synced this session with same values — nothing to do */
  if (lastRate === String(rate) && lastCode === code) return;

  sessionStorage.setItem(SK_RATE, String(rate));
  sessionStorage.setItem(SK_CODE, code);

  /* USD: clear attributes so Liquid defaults to 1.0 cleanly */
  const attrs = {};
  if (rate === 1.0 && code === 'USD') {
    attrs.cs_currency_rate = '';
    attrs.cs_currency_code = '';
  } else {
    attrs.cs_currency_rate = String(rate);
    attrs.cs_currency_code = code;
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attrs }),
  })
    .catch(function () {});
})();
